import type { enOps } from "./en.ops";

/** Russian for the operations screens (see `en.ops.ts`). Words from the boards Today … SettingsAlerts. */
export const ruOps: Record<keyof typeof enOps, string> = {
  "ops.open": "Открыть",
  "ops.cancel": "Отмена",
  "ops.refresh": "Обновить",
  "ops.more": "Ещё",
  "ops.yes": "Да",
  "ops.foot.spend": "Расход Facebook {age} назад",
  "ops.today.day": "день по {tz}",
  "ops.today.stale": "не обновилось — показаны прошлые цифры",
  "ops.today.wasAt": "вчера к {at}: {value}",
  "ops.today.yesterday": "вчера {value}",
  "ops.today.holdLeads": "{leads} лидов × апрув {rate}",
  "ops.today.chart.was": "вчера {value}",
  "ops.today.chart.end": "вчера итог {value}",
  "ops.today.allCampaigns": "Все кампании",
  "ops.today.byProfit": "по профиту",
  "ops.today.best.empty": "Сегодня в плюсе пока никого",
  "ops.today.worst.empty": "Сегодня никто не в минусе",
  "ops.today.att.losing": "ROI {roi} сегодня при расходе {cost} · апрув {ar}",
  "ops.today.att.noClicks": "Нет кликов сегодня, расход идёт: {cost}",
  "ops.first.subtitle": "Кампаний пока нет — домен, из чего собрать кампанию, затем сама кампания",
  "ops.first.waiting": "появится после первых кликов",
  "ops.first.title": "Готово к первой кампании",
  "ops.first.progress": "{done} из {total}",
  "ops.first.counted": "Есть: {count}",
  "ops.first.network.done": "{name} подключена",
  "ops.first.network.todo": "Партнёрка принимает лидов и присылает постбеки",
  "ops.first.network.add": "Добавить партнёрку",
  "ops.first.source": "Источник",
  "ops.first.source.done": "{name}: метка клика {param}",
  "ops.first.source.todo": "Где покупается трафик: Facebook, TikTok, Google",
  "ops.first.source.add": "Добавить источник",
  "ops.first.offer.todo": "Добавьте ссылку партнёрки и выплату — без этого трекер не знает, куда вести человека",
  "ops.first.offer.add": "Добавить оффер",
  "ops.first.lander.todo": "Загрузите ZIP или укажите адрес страницы, которую человек увидит до оффера",
  "ops.first.lander.add": "Добавить ленд",
  "ops.first.road": "Как идёт человек",
  "ops.first.road.ad": "Реклама",
  "ops.first.road.domain": "Ваш домен",
  "ops.first.road.lander": "Ленд",
  "ops.first.road.offer": "Оффер",
  "ops.first.road.network": "Партнёрка",
  "ops.first.road.body": "Человек нажимает рекламу и попадает на ваш домен. Трекер записывает клик, показывает ленд и отправляет на оффер партнёрки. Когда партнёрка присылает постбек, клик становится лидом, потом апрувом.",
  "ops.first.spend": "Расход подтянется сам",
  "ops.first.spend.body": "Для кампаний Facebook расход приходит из кабинетов через vibe-fb каждые 15 минут.",
  "ops.health.subtitle": "Всё, из-за чего цифры в отчётах могут разойтись с правдой",
  "ops.health.checkNow": "Проверить сейчас",
  "ops.health.k.problems": "Проблемы",
  "ops.health.k.problems.note": "ломают цифры",
  "ops.health.k.warnings": "Предупреждения",
  "ops.health.k.warnings.note": "могут сломать",
  "ops.health.k.ok": "В норме",
  "ops.health.k.ok.note": "проверок из {total}",
  "ops.health.k.last": "Последняя проверка",
  "ops.health.k.last.note": "раз в минуту",
  "ops.health.sortOut": "Нужно разобраться",
  "ops.health.sortOut.note": "сначала то, что ломает деньги",
  "ops.health.breaks": "Что ломает",
  "ops.health.fine": "В норме",
  "ops.health.fold": "Свернуть",
  "ops.health.unfold": "Развернуть",
  "ops.health.ago": "{age} назад",
  "ops.health.since": "с {at}",
  "ops.health.empty": "пусто",
  "ops.health.clicks": "Клики пишутся",
  "ops.health.clicks.ok": "задержка {lag}, очередь пуста",
  "ops.health.clicks.last": "последний клик {age} назад",
  "ops.health.clicks.none": "за сутки ни одного клика",
  "ops.health.clicks.noneShort": "ни одного за сутки",
  "ops.health.clicks.breaks": "Кликов давно нет: домен не отвечает, кампании на паузе или трафик идёт мимо трекера.",
  "ops.health.toDomains": "К доменам",
  "ops.health.postbacks": "Постбеки принимаются",
  "ops.health.postbacks.ok": "{count} за сутки, {share} сопоставлены",
  "ops.health.postbacks.none": "за сутки постбеков не было",
  "ops.health.rates": "Курсы валют",
  "ops.health.rates.ok": "обновлены {at}, валют: {count}",
  "ops.health.rates.never": "ещё не загружались",
  "ops.health.fx": "Конверсии без курса",
  "ops.health.fx.ok": "0 за сутки",
  "ops.health.fx.breaks": "Выплаты в {codes} не попали в доход, пока нет курса.",
  "ops.health.dlq": "Очередь ошибок (DLQ)",
  "ops.health.stuck": "Зависшие события",
  "ops.health.stuck.ok": "0 старше 5 мин",
  "ops.health.reports": "Отчёты",
  "ops.health.reports.ok": "отстают от кликов на {age}",
  "ops.health.spend": "Расход Facebook",
  "ops.health.spend.ok": "{age} назад, объявлений за сутки: {ads}",
  "ops.health.spend.none": "vibe-fb ещё не присылал расход",
  "ops.health.spend.breaks": "Расход из кабинетов давно не приходил: профит и ROI кампаний Facebook завышены.",
  "ops.health.toSources": "К источникам",
  "ops.health.leads": "Лиды доставлены партнёрам",
  "ops.health.spendNoClicks": "Расход без кликов",
  "ops.health.spendNoClicks.ok": "весь расход за 7 дней — с визитами",
  "ops.health.spendNoClicks.badge": "{sum} USD за 7 дней",
  "ops.health.showCampaigns": "Показать кампании",
  "ops.health.noClick": "Постбеки без клика",
  "ops.health.noClick.ok": "все постбеки нашли клик",
  "ops.health.noClick.breaks": "{networks} шлёт клик, которого трекер не знает. Лиды не попадут в отчёты, пока клик не найдётся.",
  "ops.health.replay": "Повторить {count}",
  "ops.health.unmapped": "Неизвестный статус партнёрки",
  "ops.health.unmapped.ok": "все статусы сопоставлены",
  "ops.health.unmapped.breaks": "{list}. Такие лиды стоят в холде — апрув-рейт занижен.",
  "ops.health.map": "Сопоставить статус",
  "ops.health.silent": "Партнёрки присылают постбеки",
  "ops.health.silent.ok": "ни одна не молчит дольше заданного",
  "ops.clicks.class.human": "Люди",
  "ops.clicks.class.all": "Люди и боты",
  "ops.clicks.city": "Город",
  "ops.clicks.device": "Устройство · ОС · браузер",
  "ops.clicks.asn": "ASN",
  "ops.clicks.lander": "Ленд",
  "ops.clicks.conv": "Конв.",
  "ops.clicks.leads": "{count} лид",
  "ops.clicks.search": "clickid, IP, sub1–sub20",
  "ops.bots.who": "Кого отсеяли",
  "ops.bots.share": "{pct} визитов",
  "ops.bots.notClicks": "Боты не считаются кликами",
  "ops.bots.notClicks.body": "Их не видно в CR и EPC. Ленд и оффер им показываются по правилу «бот» в потоке кампании — обычно белая страница.",
  "ops.bots.hint.meta_crawler": "Проверка объявления площадкой: ASN Facebook, facebookexternalhit",
  "ops.bots.hint.datacenter": "IP хостинга или облака, не домашний провайдер",
  "ops.bots.hint.listed_ip": "IP из общего списка ботов",
  "ops.bots.hint.crawler": "Поисковый робот или сканер по User-Agent",
  "ops.bots.hint.no_ua": "Запрос без User-Agent — так браузеры не ходят",
  "ops.bots.hint.bot_score": "Поведение: оценка бота выше порога",
  "ops.bots.hint.verified_bot": "Подтверждённый робот: Google, Bing и подобные",
  "ops.bots.why": "Почему бот",
  "ops.bots.why.listed": "IP в списке ботов",
  "ops.bots.why.noUa": "без User-Agent",
  "ops.bots.why.score": "оценка {score}",
  "ops.bots.ip": "IP",
  "ops.pb.request": "В запросе",
  "ops.src.subtitle": "Откуда идёт трафик. Источник задаёт, какие метки несёт клик и откуда берётся расход",
  "ops.src.col.source": "Источник",
  "ops.src.platform": "Площадка",
  "ops.src.col.clickId": "Метка клика",
  "ops.src.col.campaigns": "Кампании",
  "ops.src.col.way": "Расход тянется",
  "ops.src.way.api": "Из API",
  "ops.src.way.apiAge": "Из API · {age} назад",
  "ops.src.way.late": "API отстаёт",
  "ops.src.way.manual": "Вручную",
  "ops.src.way.none": "Не подключён",
  "ops.src.where": "Откуда берётся расход",
  "ops.src.where.note": "без расхода нет профита и ROI",
  "ops.src.where.fb": "{name} · vibe-fb",
  "ops.src.where.api": "Объявлений за сутки: {ads}, синхронизация каждые 15 минут, последняя {age} назад",
  "ops.src.where.manual": "API не подключён. Расход вносится вручную в настройках кампании или приходит меткой клика",
  "ops.src.where.noSpend": "Кампании есть, расхода за период нет",
  "ops.src.where.noCampaigns": "Кампаний нет",
  "ops.src.where.check": "Здоровье данных",
  "ops.src.where.connectApi": "Подключить API",
  "ops.src.where.connect": "Подключить",
  "ops.src.newTitle": "Новый источник",
  "ops.src.editTitle": "Источник: {name}",
  "ops.src.used": "Используется в {count} {campaigns} — изменения применятся к новым кликам",
  "ops.src.unused": "Пока не используется ни в одной кампании",
  "ops.src.template": "Шаблон рекламной ссылки",
  "ops.src.template.hint": "Вставьте в поле «Параметры URL» объявления. Домен и путь подставит кампания.",
  "ops.src.macros": "Макросы площадки — нажмите, чтобы вставить",
  "ops.src.clickId": "Метка клика",
  "ops.src.fields": "Что пишется в клик",
  "ops.src.add": "Добавить",
  "ops.src.col.param": "Параметр",
  "ops.src.col.what": "Что это",
  "ops.src.col.macro": "Из макроса",
  "ops.src.col.example": "Пример",
  "ops.src.example.hint": "Из последнего клика источника за 7 дней",
  "ops.src.own": "Своя метка",
  "ops.src.add.none": "Все параметры площадки уже в ссылке",
  "ops.src.aliases": "Те же метки под другими именами",
  "ops.src.aliases.hint": "Если ссылка пришла с utm_placement вместо sub4, клик запишет его в sub4. Работает на доменах поверх чужого сайта.",
  "ops.src.aliases.placeholder": "utm_placement=sub4",
  "ops.src.aliases.invalid": "Слева — имя метки латиницей, справа — sub1…sub20",
  "ops.src.what.campaignId": "ID кампании",
  "ops.src.what.adSetId": "ID адсета",
  "ops.src.what.adId": "ID объявления",
  "ops.src.what.placement": "Плейсмент",
  "ops.src.what.campaignName": "Название кампании",
  "ops.src.what.adSetName": "Название адсета",
  "ops.src.what.adName": "Название объявления",
  "ops.src.what.siteSource": "Где показано (fb, ig, an, msg)",
  "ops.src.what.adGroupId": "ID группы объявлений",
  "ops.src.what.adGroupName": "Название группы объявлений",
  "ops.src.what.creativeId": "ID объявления (креатива)",
  "ops.src.what.keyword": "Ключевое слово",
  "ops.src.what.network": "Сеть (g, s, d)",
  "ops.src.what.device": "Устройство",
  "ops.src.what.clickId": "ID клика",
  "ops.src.remove": "Убрать параметр",
  "ops.src.spend": "Расход",
  "ops.src.spend.fb": "Расход приходит из vibe-fb",
  "ops.src.spend.fb.last": "по объявлениям, каждые 15 минут · последний {age} назад, объявлений за сутки: {ads}",
  "ops.src.spend.fb.never": "по объявлениям, каждые 15 минут · пока ни разу",
  "ops.src.costMacros": "Метки расхода в ссылке",
  "ops.src.costMacros.hint": "Если площадка передаёт цену клика в ссылке (spend, cpc) — через запятую",
  "ops.src.capi": "Конверсии в Facebook отправляет vibe-fb",
  "ops.src.capi.body": "Трекер передаёт апрувы в Conversions API через кабинет — отдельный постбек в источник не нужен.",
  "ops.src.saved": "Источник «{name}» сохранён",
  "ops.src.archive.title": "Убрать «{name}» в архив?",
  "ops.src.archive.body": "Источник пропадёт из выбора в новых кампаниях.",
  "ops.src.archive.used": "На нём {count} {campaigns}: их клики продолжат записываться, новые кампании его не выберут.",
  "ops.src.archived": "«{name}» в архиве",
  "ops.dom.subtitle": "Адрес, на котором живёт рекламная ссылка. Человек сначала попадает на него и только потом — на ленд и оффер",
  "ops.dom.connect": "Подключить домен",
  "ops.dom.usage": "Какие домены",
  "ops.dom.usage.all": "Все",
  "ops.dom.usage.busy": "Заняты",
  "ops.dom.usage.free": "Свободны",
  "ops.dom.usage.problems": "Проблемы",
  "ops.dom.search": "Поиск по адресу",
  "ops.dom.none": "Таких доменов нет",
  "ops.dom.col.campaigns": "Кампании",
  "ops.dom.col.where": "Где",
  "ops.dom.col.checked": "Проверен",
  "ops.dom.checkNow": "Проверить сейчас",
  "ops.dom.unbind": "Отвязать",
  "ops.dom.unbind.title": "Отвязать {fqdn}?",
  "ops.dom.unbind.body": "Трекер перестанет отвечать на этом домене. Сам домен останется у провайдера.",
  "ops.dom.unbind.used": "На нём {count} {campaigns}: их ссылки перестанут работать. Сам домен останется у провайдера.",
  "ops.dom.free": "Свободен",
  "ops.dom.fixAt": "Исправить у провайдера",
  "ops.dom.records": "DNS-записи",
  "ops.dom.checkedAt": "проверено {at}",
  "ops.dom.proxied": "Через прокси",
  "ops.dom.dnsOnly": "Только DNS",
  "ops.dom.connection": "Подключение",
  "ops.dom.where": "Где",
  "ops.dom.mode": "Режим",
  "ops.dom.mode.direct": "весь домен",
  "ops.dom.mode.overlay": "поверх сайта",
  "ops.dom.ref": "ID у провайдера",
  "ops.dom.added": "Добавлен",
  "ops.dom.default": "Основной",
  "ops.dom.default.yes": "да — новые кампании берут его",
  "ops.dom.default.no": "нет",
  "ops.dom.campaigns": "Кампании на домене",
  "ops.dom.campaigns.none": "Ни одна кампания не использует этот домен",
  "entry.title": "Входы",
  "entry.add": "Добавить вход",
  "entry.none": "Нет входов: каждая кампания идёт по своему пути. Вход — одна ссылка на домен, кампанию выбирает ключ в ссылке.",
  "entry.campaigns.count": "кампаний: {n}",
  "entry.new": "Новый вход",
  "entry.create": "Создать вход",
  "entry.created": "Вход создан — домен публикуется",
  "entry.saved": "Вход сохранён — домен публикуется",
  "entry.saveFailed": "Не удалось сохранить вход",
  "entry.name.ph": "Основной",
  "entry.path": "Путь",
  "entry.selectors": "Как узнать кампанию по ссылке",
  "entry.byKey": "Ключ в ссылке — ?<токен>",
  "entry.byParam": "Значение параметра",
  "entry.byParam.hint": "Имя параметра: ?c=<токен>. Пусто — не используется",
  "entry.rules": "Правила (без токена)",
  "entry.rules.hint": "Если токена в ссылке нет: первое совпавшее правило отдаёт визит своей кампании.",
  "entry.rules.add": "Добавить правило",
  "entry.rule.field": "Поле",
  "entry.rule.param": "Параметр",
  "entry.rule.op": "Условие",
  "entry.rule.values": "Значения",
  "entry.rule.campaign": "Кампания",
  "entry.fallback": "Если ничего не совпало",
  "entry.fallback.origin": "Сайт домена (как есть)",
  "entry.fallback.not_found": "404",
  "entry.fallback.redirect": "Редирект на адрес",
  "entry.fallback.campaign": "Кампания по умолчанию",
  "entry.fallback.url": "Адрес",
  "entry.fallback.campaign.label": "Кампания",
  "entry.sticky": "Помнить вернувшегося",
  "entry.sticky.off": "Не помнить",
  "entry.sticky.hour": "Час",
  "entry.sticky.day": "Сутки",
  "entry.sticky.week": "Неделю",
  "entry.sticky.month": "30 дней",
  "entry.active": "Вход работает",
  "entry.active.hint": "Выключенный вход снимается с домена; кампании со своим путём продолжают работать",
  "entry.archive.title": "Архивировать вход «{name}»?",
  "entry.archive.body": "Путь входа освободится, ссылки с токенами перестанут вести в кампании. Кампании со своим путём продолжат работать.",
  "entry.campaigns": "Кампании за входом",
  "entry.campaigns.none": "Пока ни одной: добавьте кампанию этого домена — у неё появится свой токен и ссылка.",
  "entry.campaigns.allBound": "Все кампании домена уже за этим входом",
  "entry.campaign.pick": "Кампания…",
  "entry.campaign.inactive": "не активна — визиты уходят в «по умолчанию»",
  "entry.unbind": "Убрать из входа",
  "entry.bind": "Добавить",
  "entry.token": "Токен",
  "entry.token.ph": "токен (пусто — новый UUID)",
  "entry.token.bad": "Буквы, цифры, _ . - (до 100)",
  "ed.domain.entries": "Ссылки через вход",
  "ed.domain.entries.pick": "Поставить за вход…",
  "ops.dom.provider.manual": "DNS вручную",
  "ops.set.instant": "изменения сохраняются сразу",
  "ops.set.workspace": "Рабочее пространство",
  "ops.set.name.hint": "Видно в рейле и в выгрузках",
  "ops.set.tz.hint": "По нему режутся дни в отчётах, «Сегодня» и лимиты офферов. Смена пересчитает отчёты задним числом",
  "ops.set.currency": "Валюта отчётов",
  "ops.set.currency.hint": "Выплаты в других валютах переводятся по курсу ECB на день конверсии",
  "ops.set.currency.usd": "USD — доллар США",
  "ops.goals.about": "Цель — то, за что платит партнёрка. Постбек приносит ключ цели; доходные цели попадают в «Доход», основная — в «Лиды» и CR.",
  "ops.goals.primary": "Основная",
  "ops.goals.editTitle": "Цель «{name}»",
  "ops.goals.key": "Ключ в постбеке",
  "ops.al.new": "Новое оповещение",
  "ops.al.newTitle": "Новое оповещение",
  "ops.al.editTitle": "Оповещение: {name}",
  "ops.al.defaultName": "Кампании сливают",
  "ops.al.empty": "Оповещений пока нет",
  "ops.al.empty.body": "Оповещение следит за цифрой — ROI, CPA, расходом — и пишет, когда она уходит за порог.",
  "ops.al.col.severity": "Важность",
  "ops.al.col.rule": "Правило",
  "ops.al.col.when": "Когда срабатывает",
  "ops.al.col.scope": "Для чего",
  "ops.al.col.last": "Сработало",
  "ops.al.col.on": "Вкл.",
  "ops.al.scope": "Для каких кампаний",
  "ops.al.scope.all": "Все кампании вместе",
  "ops.al.scope.hint": "Без кампании оповещение смотрит на цифры всего пространства",
  "ops.al.summary": "{cond} за {window}",
  "ops.al.window.hours": "{count} ч",
  "ops.al.window.days": "{count} {days}",
  "ops.al.word.days": "день|дня|дней",
  "ops.al.window": "За окно",
  "ops.al.window.last": "последние {window}",
  "ops.al.cooldown": "Не чаще",
  "ops.al.cooldown.value": "раз в {window}",
  "ops.al.when": "Когда",
  "ops.al.metric": "Что",
  "ops.al.op": "Сравнение",
  "ops.al.value": "Порог",
  "ops.al.kind.roiBelow": "ROI",
  "ops.al.kind.cpaAbove": "CPA",
  "ops.al.kind.spendSpike": "Рост расхода",
  "ops.al.kind.conversionDrop": "Падение апрувов",
  "ops.al.kind.zeroConversions": "Нет апрувов",
  "ops.al.zero.withClicks": "при кликах",
  "ops.al.hint.roiBelow": "ROI ниже порога при расходе больше нуля",
  "ops.al.hint.cpaAbove": "Расход на апрув выше порога; расход без апрувов — сразу «Важно»",
  "ops.al.hint.spendSpike": "Расход вырос больше чем на порог к прошлому такому же окну",
  "ops.al.hint.conversionDrop": "Апрувов меньше, чем в прошлом окне, больше чем на порог",
  "ops.al.hint.zeroConversions": "Клики есть, апрувов ноль",
  "ops.al.severity": "Важность",
  "ops.al.where": "Куда",
  "ops.al.where.tracker": "В трекере — всегда: история срабатываний",
  "ops.al.where.owner": "Автору оповещения — в его личные уведомления",
  "ops.al.dest.noHub": "Хаб уведомлений здесь не подключён — оповещение всё равно срабатывает в трекере.",
  "ops.al.dest.loading": "Загружаем каналы организации…",
  "ops.al.dest.loadFailed": "Не удалось загрузить каналы организации — выбор оповещения сохранится.",
  "ops.al.dest.adminOnly": "Каналы организации выбирает её владелец или админ.",
  "ops.al.dest.picked": "Выбрано: {count}.",
  "ops.al.dest.empty": "У организации ещё нет каналов — админ подключает их в консоли, «Уведомления».",
  "ops.al.dest.gone": "Отключено каналов из выбранных: {count}.",
  "ops.al.fired": "Сработало {count} раз, последнее {at}",
  "ops.al.neverFired": "Ещё не срабатывало",
  "ops.al.saved": "Оповещение «{name}» сохранено",
  "ops.al.err.name": "Назовите оповещение",
  "ops.al.err.value": "Укажите порог",
  "ops.al.err.number": "Порог — число",
  "ops.al.delete.title": "Удалить оповещение «{name}»?",
};
